import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faHourglassHalf,
  faCircle,
  faRoute,
} from "@fortawesome/free-solid-svg-icons";

export default function MilestonesTableComponent({
  milestones,
  title = "Milestones",
  showReviewedBy = false,
}) {
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    try {
      const d = new Date(dateString);
      return d.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateString;
    }
  };

  const getStepColor = (milestone) => {
    if (milestone.completed)
      return milestone.status === "REJECTED" ? "#dc3545" : "#198754";
    if (milestone.isPending) return "#fd7e14";
    return "#6c757d";
  };

  const getStepIcon = (milestone) => {
    if (milestone.completed) {
      return milestone.status === "REJECTED" ? faTimesCircle : faCheckCircle;
    }
    return milestone.isPending ? faHourglassHalf : faCircle;
  };

  return (
    <div className="card rounded-3 border-vcg-muted">
      <div className="card-body p-4">
        <h5 className="fw-bold mb-4">
          <FontAwesomeIcon icon={faRoute} className="me-2" />
          {title}
        </h5>
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>Status</th>
                <th>Step</th>
                <th>Completed</th>
                <th>Completed At</th>
                <th>Reason</th>
                {showReviewedBy && <th>Reviewed By</th>}
              </tr>
            </thead>
            <tbody>
              {milestones.map((milestone, idx) => (
                <tr key={idx}>
                  <td style={{ width: 90 }}>
                    <span
                      className="d-inline-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: 36,
                        height: 36,
                        background: getStepColor(milestone),
                        color: "#fff",
                      }}
                    >
                      <FontAwesomeIcon icon={getStepIcon(milestone)} />
                    </span>
                  </td>
                  <td style={{ minWidth: 260 }}>{milestone.displayName}</td>
                  <td>
                    {milestone.completed ? (
                      <span className="badge bg-success">Yes</span>
                    ) : (
                      <span className="badge bg-secondary">No</span>
                    )}
                  </td>
                  <td style={{ minWidth: 180 }}>
                    {milestone.completedAt
                      ? formatDateTime(milestone.completedAt)
                      : "-"}
                  </td>
                  <td style={{ maxWidth: 300 }}>{milestone.reason || "N/A"}</td>
                  {showReviewedBy && (
                    <td style={{ minWidth: 180 }}>
                      {milestone.reviewedBy || "N/A"}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
